export default __webpack_public_path__ + "static/media/promotion.8a5b8b2e.png";